import { useUserStore } from '~/stores/auth';
import { FEATURE_FLAGS } from '~/constants/featureFlags';

interface UserState {
  user: {
    summary: {
      acceptedTermsOfService: boolean;
    };
  };
}

export default defineNuxtRouteMiddleware((to, _from) => {
  const userStore = useUserStore();
  const isTermsOfServiceRequired = useFlag(FEATURE_FLAGS.requireTermsOfService);

  const userState = userStore as unknown as UserState;

  const hasUserData = Boolean(userState.user?.summary);
  const hasAcceptedTerms = userState.user?.summary?.acceptedTermsOfService;

  const isProtectedLayout =
    to.meta.layout === 'global-navigation' || to.meta.layout === 'post-detail';

  const shouldRedirect =
    hasUserData &&
    !hasAcceptedTerms &&
    !isTermsOfServiceRequired.value &&
    isProtectedLayout;

  if (shouldRedirect) {
    return navigateTo('/terms-of-service');
  }
  return true;
});
